import { type I18nProvider } from '@refinedev/core'

import { i18n } from './index'

export const i18nProvider: I18nProvider = {
  translate: (key: string, options?: Record<string, unknown>) => {
    return options ? i18n.t(key, options) : i18n.t(key)
  },
  changeLocale: (lang: string) => i18n.changeLanguage(lang),
  getLocale: () => i18n.language,
}
